import { useState } from 'react';
import { Grid, TextField, Card, CardHeader, CardContent, CardActions } from '@mui/material';

// Components
import { ActionButton } from 'components/ui/buttons';

// Utility
import { useNotification } from 'context/notification';
import fetchExpresso from 'utility/fetchExpresso';
import { downloadFile } from 'utility/browser';
import moment from 'moment-timezone';

function initState() {
    const totalMonths = moment().month() + 4; // Add # of months from last year we want to show

    const months = [];

    for (let i = 0; i <= totalMonths; i++) {
        months.push({
            monthsAgo: i,
            label: moment().subtract(i, 'month').format('MMMM YYYY'),
        });
    }

    return {
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
        months: months,
    };
}

export default function OrderDownload() {
    const [state, setState] = useState(initState);

    const [loading, setLoading] = useState(false);

    // Utility
    const { notify } = useNotification();

    const handlePresetChange = (e) => {
        const monthsAgo = Number(e.target.value);

        // start/end are in America/Toronto timezone
        // when serialized into a string in the POST request, its being converted to UTC
        // on the server, we're converting it back to America/Toronto. This is okay for now since our admin reporting is based in our home timezone (America/Toronto)
        setState((s) => ({
            ...s,
            startDate: moment().subtract(monthsAgo, 'month').startOf('month'),
            endDate: moment().subtract(monthsAgo, 'month').endOf('month'),
        }));
    };

    const handleDownload = () => {
        setLoading(true);

        fetchExpresso('/admin/reports/full_report', {
            method: 'POST',
            body: {
                startDate: state.startDate,
                endDate: state.endDate,
            },
        })
            .then((response) => {
                switch (response.status) {
                    case 200:
                        response
                            .blob()
                            .then(async (blob) => {
                                await downloadFile(
                                    `FrontDoorPlus-Orders-${moment().format('YYYY-MM-DD')}.xlsx`,
                                    blob,
                                );
                            })
                            .catch(() => {
                                notify.error('There was a problem downloading your orders');
                            });
                        break;

                    case 204:
                        notify.warning('No orders found');
                        break;

                    default:
                        notify.error('There was a problem downloading your orders');
                        break;
                }
            })
            .catch(() => {
                notify.error('There was a problem downloading your orders');
            })
            .finally(() => setLoading(false));
    };

    return (
        <Card>
            <CardHeader title="Download Orders" />

            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            select
                            onChange={handlePresetChange}
                            variant="outlined"
                            label="Month"
                            SelectProps={{ native: true }}
                        >
                            {state.months.map((month) => (
                                <option value={String(month.monthsAgo)}>{month.label}</option>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
            </CardContent>

            <CardActions>
                <ActionButton onClick={handleDownload} disabled={loading}>
                    Download
                </ActionButton>
            </CardActions>
        </Card>
    );
}
